'use strict';

var epiVersion = require('../../api-version.json');

function isLocalHost(host) {
    var isLocal = !host || //phantomjs
        host === '127.0.0.1' ||
        host.indexOf('local.') === 0 ||
        host.indexOf('ngrok') !== -1 ||
        host.indexOf('localhost') === 0;
    return isLocal;
}

//TODO: urlutils to get host, since no window on node
var defaults = {
    protocol: isLocalHost(window.location.host) ? 'https' : window.location.protocol.replace(':', ''),
    host: window.location.host,
    pathname: window.location.pathname
};

function getLocalHost(existingFn, host) {
    var localHostFn;
    if (existingFn !== undefined) {
        if (!$.isFunction(existingFn)) {
            localHostFn = function () { return existingFn; };
        } else {
            localHostFn = existingFn;
        }
    } else {
        localHostFn = function () {
            return isLocalHost(host);
        };
    }
    return localHostFn;
}

var UrlConfigService = function (config) {
    var envConf = UrlConfigService.defaults;

    if (!config) {
        config = {};
    }
    var configOverrides = $.extend({}, defaults, config);
    var overrides = $.extend({}, envConf, config);
    var options = $.extend({}, defaults, overrides);

    overrides.isLocalhost = options.isLocalhost = getLocalHost(options.isLocalhost, configOverrides.host);

    var actingHost = config && config.host;
    if (!actingHost && options.isLocalhost()) {
        actingHost = 'forio.com';
    } else {
        actingHost = options.host;
    }

    var actingProtocol = config && config.protocol;
    if (!actingProtocol && options.isLocalhost()) {
        actingProtocol = 'https';
    } else {
        actingProtocol = options.protocol;
    }

    var HOST_API_MAPPING = {
        'forio.com': 'api.forio.com',
        'foriodev.com': 'api.epicenter.foriodev.com'
    };

    var publicExports = {
        protocol: actingProtocol,

        api: '',

        actingHost: actingHost,

        //TODO: this should really be called 'apihost', but can't because that would break too many things
        host: (function () {
            var apiHost = (HOST_API_MAPPING[actingHost]) ? HOST_API_MAPPING[actingHost] : actingHost;
            return apiHost;
        }()),

        isCustomDomain: (function () {
            var path = options.pathname.split('/');
            var pathHasApp = path && path[1] === 'app';
            return (!options.isLocalhost() && !pathHasApp);
        }()),

        appPath: (function () {
            var path = options.pathname.split('/');

            return path && path[1] || '';
        }()),

        accountPath: (function () {
            var accnt = '';
            var path = options.pathname.split('/');
            if (path && path[1] === 'app') {
                accnt = path[2];
            }
            return accnt;
        }()),

        projectPath: (function () {
            var prj = '';
            var path = options.pathname.split('/');
            if (path && path[1] === 'app') {
                prj = path[3]; //eslint-disable-line no-magic-numbers
            }
            return prj;
        }()),

        versionPath: (function () {
            var version = epiVersion.version ? epiVersion.version + '/' : '';
            return version;
        }()),

        baseURL: function () {
            var baseURL = this.protocol + '://' + this.host + '/' + this.versionPath;
            return baseURL;
        },

        getAPIPath: function (api) {
            var PROJECT_APIS = ['run', 'data', 'file', 'presence', 'project', 'multiplayer/project'];
            var apiMapping = {
                channel: 'channel/subscribe'
            };
            var apiEndpoint = apiMapping[api] || api;

            if (apiEndpoint === 'config') {
                var actualProtocol = window.location.protocol.replace(':', '');
                var configProtocol = (options.isLocalhost()) ? this.protocol : actualProtocol;
                return configProtocol + '://' + actingHost + '/epicenter/' + this.versionPath + 'config';
            }
            var baseURL = (typeof this.baseURL === 'function') ? this.baseURL() : this.baseURL;
            var apiPath;
            if (this.versionPath === 'v3') {
                apiPath = baseURL + '/' + this.accountPath + '/' + this.projectPath + '/' + apiEndpoint + '/';
            } else {
                apiPath = baseURL + apiEndpoint + '/';
                if (PROJECT_APIS.indexOf(apiEndpoint) !== -1) {
                    apiPath += this.accountPath + '/' + this.projectPath + '/';
                }
            }
            
            return apiPath;
        }
    };


    $.extend(publicExports, overrides);
    return publicExports;
};
// This data can be set by external scripts, for loading from an env server for eg;
UrlConfigService.defaults = {};

module.exports = UrlConfigService;


// WEBPACK FOOTER //
// ./src/service/url-config-service/index.js